import React from 'react'
import MenuMasterKnowledgeTagInPutBase from './MenuMasterKnowledgeTagInPutBase';

export default function MenuMasterKnowledgeTagInPutBaseNotAuthen(props) {
    // common projectInuse state
  const projectDetail = {};
  const isProjectManager = false;
  let userListOfProject = [];
  const b2bCustomerList = [];
  const b2bSupportList = [];
  
  return (
    <MenuMasterKnowledgeTagInPutBase
            {...props}
            projectDetail={projectDetail}
            isProjectManager={isProjectManager}
            userListOfProject={userListOfProject}
            b2bSupportList={b2bSupportList}
            b2bCustomerList={b2bCustomerList}
        />
  )
}
